<template>
  <div>
    <header class="hero-multi">
      <div class="bb-container">
        <div class="hero-multi__container">
          <div class="hero-multi__left">
            <h1 class="hero-multi__title">
              Die
              <span class="hero-multi__break">Multi-Shop-</span>Wunschliste für alles, was du dir wünschst
            </h1>
            <div class="hero-multi__actions">
              <bbButton
                label="Erstelle deine Wunschliste"
                class="button--lg button--accent"
                @click="$router.push({ path: $t('routes.signup', 'de-DE') })"
              />
              <!-- <a
                @click="$router.push({ name: 'guest', params: { id: exampleListId } })"
                class="link link--bold link--underline"
              >
                Ver una lista de ejemplo
              </a> -->
            </div>
          </div>
          <div class="hero-multi__cover">
            <picture>
              <source
                srcset="../../assets/img/covers/cover-fr-hero@2x.png"
                media="(min-width: 1399px) and (min-device-pixel-ratio: 2)"
              />
              <img src="../../assets/img/covers/cover-multi-hero.webp" alt="" />
            </picture>
          </div>
        </div>
      </div>
    </header>

    <section class="rate-app">
      <div class="bb-container">
        <div class="rate-app__container">
          <div class="rate-app__title">
            Mehr als 100.000 Personen haben HelloWish genutzt, um ihre Wünsche zu erfüllen.
          </div>
          <div class="rate-app__card">
            <div class="rate-app__item">
              <div class="rate-app__logo">
                <img src="../../assets/img/ico/ico-google-play.svg" alt="Google Play" />
              </div>
              <div class="rate-app__rate">4,8</div>
              <div class="rate-app__star">
                <img src="../../assets/img/ico/ico-star-fill.svg" alt="" />
              </div>
            </div>
            <hr />
            <div class="rate-app__item">
              <div class="rate-app__logo">
                <img src="../../assets/img/ico/ico-app-store.svg" alt="Apple App Store" />
              </div>
              <div class="rate-app__rate">4,8</div>
              <div class="rate-app__star">
                <img src="../../assets/img/ico/ico-star-fill.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="tiendas-list">
      <div class="tiendas-list__title">Erhalte jedes Produkt aus jedem Geschäft</div>
      <div class="tiendas-list__items">
        <VueSlickCarousel v-bind="shopSlider">
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-amazon.svg" alt="Amazon" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-ikea.svg" alt="IKEA" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-etsy.svg" alt="Etsy" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-sephora.svg" alt="Sephora" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-hm.svg" alt="H & M" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-maisons.svg" alt="Maisons du monde" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-zara.svg" alt="Zara" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-fr-kiavi.svg" alt="Kiavi" />
          </div>
        </VueSlickCarousel>
      </div>
    </section>

    <section class="hbbm-verticales">
      <div class="hbbm-verticales__container bb-container">
        <h3 class="hbbm-verticales__title">
          Perfekt für <span>jeden Anlass</span>
        </h3>
        <div class="hbbm-verticales__items">
          <VueSlickCarousel v-bind="verticalesSlider" dotsClass="slick-dots">
            <div class="hbbm-verticales__item" v-for="item in verticales" :key="item.name">
              <component
                :is="item.path ? 'router-link' : 'div'"
                :to="item.path || undefined"
                class="hbbm-verticales__content"
              >
                <div class="hbbm-verticales__name">
                  {{ item.name }}
                </div>
                <picture class="hbbm-verticales__image">
                  <img :src="item.cover" :alt="item.name" />
                </picture>
              </component>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </section>

    <section class="app-avanzada">
      <div class="bb-container">
        <div class="app-avanzada__container">
          <aside class="app-avanzada__left">
            <div class="app-avanzada__title">
              Die beste Wunschlisten-App ist <span>kostenlos</span>
            </div>
            <div class="app-avanzada__description">
              Entdecke unsere kostenlose App mit allem, was du brauchst, um deine perfekte Wunschliste zu erstellen.
            </div>
            <div class="app-avanzada__stores" target="_blank">
              <a :href="$t('links.mobileAppUrlAndroid', 'es-ES')">
                <img
                  loading="lazy"
                  src="../../assets/img/logos/logo-app-google.en-GB.svg"
                  alt=""
                  width="140"
                  height="40"
                />
              </a>
              <a :href="$t('links.mobileAppUrlIos', 'es-ES')" target="_blank">
                <img
                  loading="lazy"
                  src="../../assets/img/logos/logo-app-appstore.en-GB.svg"
                  alt=""
                  width="140"
                  height="40"
                />
              </a>
            </div>
          </aside>
          <picture class="app-avanzada__cover">
            <img
              src="../../assets//img/covers/mockup_lista_general_EN.webp"
              :alt="'Die beste Wunschlisten-App ist kostenlos'"
            />
          </picture>
        </div>
      </div>
    </section>

    <main class="home-beneficios">
      <div class="bb-container">
        <div class="home-beneficios__items">
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img src="../../assets/img/covers/cover-multi-bolso-iphone.webp" alt="" />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Wähle jedes Produkt aus jedem Geschäft
              </div>
              <div class="home-beneficios__description">
                Du hast völlige Freiheit, genau das auszuwählen, was du möchtest.
              </div>
              <ul class="home-beneficios__list">
                <li>Einzigartige Produkte kleiner Marken</li>
                <li>Die besten Angebote großer Geschäfte</li>
              </ul>
            </div>
          </section>

          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img
                src="../../assets//img/covers/cover-multi-recibiendo-dinero-002-en.webp"
                alt="Erhalten Sie auch Geld für Ihre Wünsche"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Erhalte auch Geld für deine Wünsche
              </div>
              <div class="home-beneficios__description">
                Deine Wunschliste enthält ein digitales Sparschwein, in dem du Geld für bestimmte Käufe oder allgemeine Zwecke sammeln kannst.
              </div>
              <div class="home-beneficios__actions">
                <div
                  class="link link--bold link--underline"
                  @click="$router.push({ name: 'hucha-de-nacimiento' })"
                >
                  Weitere Informationen
                </div>
              </div>
            </div>
          </section>

          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img
                src="../../assets//img/covers/monitorizacion-precios-wishlist-EN.webp"
                alt="Kaufen Sie zum richtigen Zeitpunkt"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Kaufe zum richtigen Zeitpunkt
              </div>
              <div class="home-beneficios__description">
                Wir benachrichtigen dich, wenn sich der Preis deiner Lieblingsprodukte ändert.
              </div>
              <div class="home-beneficios__footnote">
                *Wir verfolgen nur Preise unserer Partnergeschäfte.
              </div>
            </div>
          </section>
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover home-beneficios__cover--rounded">
              <img
                src="../../assets/img/covers/promos_home.webp"
                alt="Verpasse keinen Deal mehr"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Verpasse keinen Deal mehr
              </div>
              <div class="home-beneficios__description">
                Nutze die Angebote deiner Lieblingsshops direkt aus deiner Wunschliste.
              </div>
              <div class="home-beneficios__actions">
                <a
                  class="link link--bold link--underline"
                  :href="$t('routes.deals', 'de-DE')"
                >
                  Mehr erfahren
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>

    <div class="feedback-int">
      <div class="bb-container">
        <div class="feedback-int__title">Schöne Dinge, die unsere Nutzer sagen</div>
        <div class="feedback-int__items">
          <VueSlickCarousel v-bind="reviewsSlider">
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-marta.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    „Eine super nützliche App, um Geschenkelisten zu erstellen, sei es zur Ankunft eines Babys, zur Taufe oder zum Geburtstag.“
                  </div>
                  <div class="feedback-user__name">Stephanie</div>
                </div>
              </div>
            </div>

            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-estefania.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    „Genau das, wonach ich gesucht habe. Ich wollte nicht auf nur ein Geschäft oder eine Website für meine Wunschliste beschränkt sein.“
                  </div>
                  <div class="feedback-user__name">Sarah</div>
                </div>
              </div>
            </div>

            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-ichamar.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    „Eine sehr praktische App, um im Blick zu behalten, was man benötigt, es an Kontakte zu senden und das Budget entsprechend zu planen.“
                  </div>
                  <div class="feedback-user__name">Juan Carlos</div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>

    <section class="multi-share">
      <div class="bb-container">
        <div class="multi-share__container">
          <article class="multi-share__article">
            <div class="multi-share__title">Teile deine Wünsche ganz einfach</div>
            <div class="multi-share__description">
              Das Teilen deiner Liste ist so einfach wie das Kopieren und Einfügen eines Links.  Deine Familie und Freunde müssen sich nicht registrieren oder etwas herunterladen. 
            </div>
          </article>
          <picture class="multi-share__cover">
            <img
              src="../../assets/img/covers/cover-multi-men-share.webp"
              alt="Teilen Sie Ihre Wünsche einfach"
            />
          </picture>
        </div>
      </div>
    </section>

    <section class="cta-yellow-deseos">
      <div class="bb-container">
        <div class="cta-yellow-deseos__cta">
          <div class="cta-yellow-deseos__left">
            <div class="cta-yellow-deseos__title">
              Erstelle deine Wunschliste mit deinen Lieblingsprodukten aus jedem Geschäft.
            </div>
            <div class="cta-yellow-deseos__actions">
              <bbButton
                label="Jetzt starten"
                class="button--accent button--lg"
                @click="$router.push({ path: $t('routes.signup', 'de-DE') })"
              />
              <!-- <div
                class="link link--bold link--underline"
                @click="$router.push({ name: 'guest', params: { id: exampleListId } })"
              >
                Ver una lista de ejemplo
              </div> -->
            </div>
          </div>
          <div class="cta-yellow-deseos__cover">
            <img src="../../assets/img/covers/cover-multi-ext-share.webp" alt="" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import bbButton from "../../components/buttons/bbButton.vue";

export default {
  name: "HomeWishlistDE",
  metaInfo() {
    return {
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "HelloWish",
            operatingSystem: [
              //no estic segur del format per posar més d’un valor
              "ANDROID",
              "IOS",
            ],
            applicationCategory: "LifestyleApplication",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.5", //no aconsegueixo veure ratings, tu pots?
              ratingCount: "20", //no aconsegueixo veure ratings, tu pots?
            },
            offers: {
              "@type": "Offer",
              price: "0",
            },
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "HelloWish",
            legalName: "HelloBB S.L.",
            url: "https://www.hellobb.net",
            logo: "https://www.hellobb.net/logo-hellobb-dark.svg", //posar URL on tenim el logo
            description:
              "HelloWish, deine universelle Wunschliste.",
            foundingDate: "2022",
            address: {
              "@type": "PostalAddress",
              streetAddress: "C/ Pompeu Fabra 36",
              addressLocality: "Tortosa",
              addressRegion: "Tarragona",
              postalCode: "43500",
              addressCountry: {
                "@type": "Country",
                name: "Spain", //en anglés millor?
              },
            },
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              email: "hola@hellobb.net",
            },
            sameAs: [
              "https://www.instagram.com/holahellobebe/",
              "https://www.facebook.com/holahelloBB",
              "https://www.pinterest.es/holahelloBB/",
              "https://www.crunchbase.com/organization/hellobb",
            ],
          },
        },
      ],
      title: "HelloWish, deine universelle Wunschliste",
      htmlAttrs: {
        lang: "de",
      },
      meta: [
        {
          name: "description",
          content:
            "Speichere Produkte aus jedem Geschäft, sammle Geld, teile sie ganz einfach … Entdecke, warum HelloWish die #1 Wunschlisten-App ist.",
        },
        {
          itemprop: "image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
        {
          property: "og:url",
          content: "https://www.hellobb.net",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:title",
          content: "HelloWish, deine universelle Wunschliste.",
        },
        {
          property: "og:description",
          content:
            "Speichere Produkte aus jedem Geschäft, sammle Geld, teile sie ganz einfach … Entdecke, warum HelloWish die #1 Wunschlisten-App ist",
        },
        {
          property: "og:image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
        {
          name: "twitter:title",
          content: "HelloWish, deine universelle Wunschliste.",
        },
        {
          name: "twitter:description",
          content:
            "Speichere Produkte aus jedem Geschäft, sammle Geld, teile sie ganz einfach … Entdecke, warum HelloWish die #1 Wunschlisten-App ist.",
        },
        {
          name: "twitter:image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
      ],
      link: [
        { rel: "canonical", href: "https://www.hellobb.net/de" },
        { rel: "alternate", href: "https://www.hellobb.net", hreflang: "es" },
        { rel: "alternate", href: "https://www.hellobb.net/en", hreflang: "en" },
        { rel: "alternate", href: "https://www.hellobb.net/fr", hreflang: "fr" },
        { rel: "alternate", href: "https://www.hellobb.net/it", hreflang: "it" },
        { rel: "alternate", href: "https://www.hellobb.net/nl", hreflang: "nl" },
        { rel: "alternate", href: "https://www.hellobb.net/de", hreflang: "de" },
        { rel: "alternate", href: "https://www.hellobb.net/pt", hreflang: "pt" },
        { rel: "alternate", href: "https://www.hellobb.net", hreflang: "x-default" }
      ]
    };
  },
  components: {
    bbButton,
    VueSlickCarousel,
  },
  data() {
    return {
      verticales: [
        { name: "Geburtsliste", path: "/geburtsliste", cover: "/cover-hbbm-mujer-cuna.jpg" },
        { name: "Hochzeitsliste", cover: "/cover-hbbm-wedding.jpg" },
        { name: "Geburtstagswunschliste", cover: "/cover-hbbm-globos.jpg" },
        { name: "Weihnachtsliste", cover: "/cover-hbbm-navidad.jpg" },
        {
          name: "Babyshower-Liste",
          path: "/geburtsliste",
          cover: "/cover-hbbm-babby-shower.jpg",
        },
        { name: "Geschenkliste zur Einweihung", cover: "/cover-hbbm-nueva-casa.jpg" },
      ],
      verticalesSlider: {
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        dots: false,
        slidesToScroll: 1,
        centerMode: true,
        speed: 900,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            variableWidth: true,
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              dots: true,
            },
          },
        ],
      },
      shopSlider: {
        slidesToShow: 8,
        arrows: false,
        autoplay: true,
        dots: false,

        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "20px",
        edgeFriction: 0.35,
        speed: 500,
        responsive: [
          {
            breakpoint: 1000000,
            settings: {
              slidesToShow: 8,
              // variableWidth: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            variableWidth: true,
            breakpoint: 767,
            settings: {
              // autoplay: false,
              slidesToShow: 2,
              variableWidth: true,
            },
          },
        ],
      },
      reviewsSlider: {
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              centerMode: true,
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  computed: {
    exampleListId() {
      return process.env.PREVIEW_LIST_ES_ID;
    },
  },
};
</script>

<style lang="scss" scoped></style>
